import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tet_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORIES = [
  { slug: "latest", name: "Latest" },
  { slug: "generative-ai", name: "Generative AI" },
  { slug: "ai-models", name: "AI Models" },
  { slug: "ai-companies", name: "AI Companies" },
  { slug: "ai-research", name: "AI Research" },
  { slug: "ai-tools", name: "AI Tools" },
  { slug: "ai-agents", name: "AI Agents" },
  { slug: "robotics", name: "Robotics" },
  { slug: "ai-business", name: "AI Business" },
  { slug: "ai-regulation", name: "AI Regulation" },
  { slug: "ai-safety", name: "AI Safety" },
  { slug: "open-source-ai", name: "Open Source AI" },
];

export const CATEGORY_NAMES = CATEGORIES.reduce((acc, c) => {
  acc[c.slug] = c.name;
  return acc;
}, {});

export function relativeTime(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - then);
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hour${hr > 1 ? "s" : ""} ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day} day${day > 1 ? "s" : ""} ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function exactTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString(undefined, {
    year: "numeric", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit", timeZoneName: "short",
  });
}
